const CreatorPaymentTerms = () => import(/* webpackChunkName: "group-other" */ '@/pages/CreatorPaymentTerms.vue');

export default [
  {
    path: 'creator-payment-terms',
    name: 'CreatorPaymentTerms',
    component: CreatorPaymentTerms,
  },
];
